var _rect, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _ellipse2, _ellipse3, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377 316.294C377 352.907 326.856 365 265 365C203.144 365 153 352.907 153 316.294C153 279.681 203.144 250 265 250C326.856 250 377 279.681 377 316.294Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.091 109.797C152.651 88.328 174.8 103.313 182.779 116.541C184.281 119.031 183.177 122.126 180.733 123.7C132.919 154.491 114.995 197.467 111.465 217.809C111.189 219.4 110.355 220.863 109.033 221.789C79.517 242.467 60.4643 219.846 57.7637 200.626C51.0277 152.683 90.5083 120.097 111.091 109.797Z",
    fill: "#1C1B1F",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M418.909 109.797C377.349 88.328 355.2 103.313 347.221 116.541C345.719 119.031 346.823 122.126 349.267 123.7C397.081 154.491 415.005 197.467 418.535 217.809C418.811 219.4 419.645 220.863 420.967 221.789C450.483 242.467 469.536 219.846 472.236 200.626C478.972 152.683 439.492 120.097 418.909 109.797Z",
    fill: "#1C1B1F",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.625,
    cy: 214.787,
    rx: 27.6254,
    ry: 15.2222,
    fill: "#1C1B1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263 230L263 248",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M334.055 342.464C268.408 303.923 208.33 322.758 179.243 341.465C175.402 343.935 176.211 349.483 180.505 351.038C250.898 376.545 307.311 364.348 333.813 351.83C337.763 349.964 337.822 344.676 334.055 342.464Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M428 463L393 428",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 335.082,
    cy: 360.082,
    r: 90.5819,
    fill: "#666666",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203 165C210.305 167.498 227.107 175.83 235.873 189.172",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235.874 165C228.568 167.498 211.766 175.83 203 189.172",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M294 165C301.305 167.498 318.107 175.83 326.873 189.172",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M326.874 165C319.568 167.498 302.766 175.83 294 189.172",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.668 397.069C345.543 396.993 346.4 396.906 347.24 396.808V401C347.24 405.419 350.821 409 355.24 409H358.201C362.619 409 366.201 405.419 366.201 401V393.681C368.285 394.468 370.563 394.902 372.949 394.902C382.889 394.902 390.946 387.382 390.946 378.105C390.946 372.783 388.294 368.039 384.157 364.962C384.878 360.687 385.161 356.139 385.161 351.41C385.161 325.733 362.859 304.918 335.349 304.918C307.838 304.918 285.536 325.733 285.536 351.41C285.536 356.284 285.599 360.967 286.031 365.355C282.187 368.435 279.751 373.005 279.751 378.105C279.751 387.382 287.809 394.902 297.748 394.902C300.013 394.902 302.179 394.512 304.176 393.799V401C304.176 405.419 307.757 409 312.176 409H315.137C319.555 409 323.137 405.419 323.137 401V396.938C323.975 397.015 324.831 397.083 325.707 397.143V401C325.707 405.419 329.289 409 333.707 409H336.668C341.087 409 344.668 405.419 344.668 401V397.069Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.575,
    cy: 346.76,
    rx: 11.7204,
    ry: 12.4478,
    fill: "#666666"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.084,
    cy: 346.76,
    rx: 11.7204,
    ry: 12.4478,
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.368 362.209V362.209C333.44 362.209 331.465 362.209 328.298 363.859C322.771 366.738 323.478 371.707 324.442 373.607C327.013 378.046 330.334 376.856 331.673 375.707C331.805 375.552 331.927 375.402 332.044 375.259C332.832 374.293 333.388 373.612 335.349 373.607V373.607C337.325 373.607 337.882 374.29 338.673 375.259C338.79 375.402 338.912 375.552 339.044 375.707C340.383 376.857 343.704 378.046 346.275 373.607C347.239 371.707 347.946 366.738 342.419 363.859C339.263 362.215 337.29 362.209 335.368 362.209Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/치과_구강종양.ea5a571a7d1a4bdebd2fa4a754e4e6bd.svg";
export { ForwardRef as ReactComponent };